module.exports = __webpack_public_path__ + "img/icon-order.e9fdc775.svg";